import { keepPreviousData, useQuery } from "@tanstack/react-query"
import { getPayroll } from "src/redux/api/_hr.api"

export interface PayrollFilters {
  page: number;
  month: string;
  year: string;
  employee_code: string;
}

export const payrollKeys = {
  all: ["hr-emp-payroll"] as const,
  list: (filters: PayrollFilters) => [
    ...payrollKeys.all, "list", filters
  ] as const,
}

export const usePayroll = (filters: PayrollFilters) => {
  return useQuery({
    queryKey: payrollKeys.list(filters),
    queryFn: () => getPayroll(filters),
    placeholderData: keepPreviousData,
    staleTime: 60 * 60 * 1000, 
    gcTime: 60 * 60 * 1000,
    refetchOnWindowFocus: false,
  })
}